import { push } from "connected-react-router";
import Button from "pages/_components/Button";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import React from "react";
import Row from "react-bootstrap/lib/Row";
import Grid from "react-bootstrap/lib/Grid";
import Col from "react-bootstrap/lib/Col";
import { actions as thirdPaymentActions } from "reducers/thirdPayment";
import { useDispatch } from "react-redux";
import { usePaymentsCollection } from "./usePaymentsCollection";

const RecollectionPage = () => {
    const dispatch = useDispatch();
    const { loading, error } = usePaymentsCollection();

    return (
        <>
            <Notification scopeToShow="recollections" />
            <ResponsiveHeader id="menu.payments.collections" showTitle={false} />
            <MainContainer>
                <Grid className="form-content">
                    <Row className="justify-content-center">
                        <Col xs={12} md={8} mdOffset={2}>
                            <h1 className="text-center">
                                <CustomText text="Aviso de redirección del sitio" />
                            </h1>
                        </Col>
                        <br />

                        <div className="illustration text-center">
                            {error ? (
                                <Image src="images/figma/illustrations/ticket-alert.svg" className="svg-image logo" />
                            ) : (
                                <Image src="figma/illustrations/onboarding2.svg" className="svg-image logo" />
                            )}
                        </div>
                        <Col xs={12} md={10} mdOffset={1}>
                            <div className="box box-border-soft">
                                {error ? (
                                    <CustomText text={error} />
                                ) : (
                                    <CustomText text="Al pulsar Continuar se abrirá otro sitio web seguro “Recaudaciones” en una ventana nueva, tu sesión de online banking permanecerá abierta en segundo plano" />
                                )}
                            </div>
                        </Col>
                    </Row>
                    <Row className="form-actions">
                        {error ? (
                            <Col xs={12} md={4} mdOffset={4}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="global.accept"
                                    className="btn btn-primary"
                                />
                            </Col>
                        ) : (
                            <>
                                <Col xs={12} md={4} mdOffset={2}>
                                    <Button
                                        onClick={() => dispatch(push("/desktop"))}
                                        label="forms.transaction.ticket.actions.backToHome"
                                        className="btn btn-outline"
                                    />
                                </Col>
                                <Col xs={12} md={4} mdOffset={6}>
                                    <Button
                                        onClick={() => dispatch(thirdPaymentActions.getRecollectionJWT())}
                                        label="global.continue"
                                        className="btn btn-primary"
                                        loading={loading}
                                    />
                                </Col>
                            </>
                        )}
                    </Row>
                </Grid>
            </MainContainer>
        </>
    );
};

export default RecollectionPage;
